import { gql, useQuery, QueryHookOptions } from '@apollo/client';

export const query = gql`
  query getHiveAnalytics($hiveId: String!, $startDate: DateTime, $endDate: DateTime) {
    getHiveAnalytics(hiveId: $hiveId, startDate: $startDate, endDate: $endDate) {
      numberOfGames
      totalTime
    }
  }
`;

interface HiveAnalytics {
  numberOfGames: number;
  totalTime: number;
}

export interface QueryType {
  getHiveAnalytics: HiveAnalytics;
}

export function useGetHiveAnalyticsQuery(
  hiveId: string,
  startDate?: string,
  endDate?: string,
  options?: QueryHookOptions<QueryType>,
) {
  return useQuery<QueryType>(query, {
    variables: { hiveId, startDate, endDate },
    ...options,
  });
}
